<template>
  <div>
    <h4 class="c-blue-text title-font tw-text-sm">Top Benefits</h4>
    <div class="tw-flex tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-mt-3 c-blue-text tw-text-center tw-px-2 tw-capitalize">
      <div class="tw-flex tw-flex-col tw-justify-center">
        <img src="/images/icons/tow.png" class="tw-object-none tw-object-center" alt="tow">
        <small>Towing</small>
        <p class="tw-text-xs">Free limit KSH 50,000</p>
      </div>
      <div class="tw-flex tw-flex-col tw-justify-center tw-px-2">
        <img src="/images/icons/radio.png" class="tw-object-none tw-object-center" alt="tow">
        <small class="tw-mt-2">Entertainment</small>
        <p class="tw-text-xs">Free limit KSH 50,000</p>
      </div>
      <div class="tw-flex tw-flex-col tw-justify-center tw-px-2">
        <img src="/images/icons/screen.png" class="tw-mt-0 md:tw-mt-3 tw-object-none tw-object-center" alt="tow">
        <small class="tw-mt-0 md:tw-mt-3">Windscreen</small>
        <p class="tw-text-xs">Free limit KSH 50,000</p>
      </div>
      <div class="tw-flex tw-flex-col tw-justify-center tw-px-2">
        <img src="/images/icons/violence.png" class="tw-object-none tw-object-center" alt="tow">
        <small class="tw-mt-2 c-gray-text">Political Violence & Terrorism</small>
        <p class="tw-text-xs">Value of the vehicle</p>
      </div>
    </div>

    <h4 class="c-blue-text title-font tw-text-sm">Other Benefits</h4>
    <div class="tw-flex tw-grid tw-grid-cols-1
                 md:tw-grid-cols-2">
      <div class="tw-flex tw-items-center tw-mt-3">
        <img src="/images/icons/excess-protector.png" class="tw-w-12 tw-h-12" alt="tow">
        <div class="tw-ml-3">
          <small class="tw-mt-2 c-gray-text">Excess Protector</small>
          <p class="tw-text-xs c-blue-text">Free</p>
        </div>
      </div>
      <div class="tw-flex tw-items-center tw-mt-3">
        <img src="/images/icons/repair.png" class="tw-w-12 tw-h-12" alt="tow">
        <div class="tw-ml-3">
          <small class="tw-mt-2 c-gray-text">Authorized Repair Limit</small>
          <p class="tw-text-xs c-blue-text">Free for KSH 50,0000/=</p>
        </div>
      </div>
      <div class="tw-flex tw-items-center tw-mt-3">
        <img src="/images/icons/harm.png" class="tw-w-12 tw-h-12" alt="tow">
        <div class="tw-ml-3">
          <small class="tw-mt-2 c-gray-text">Legal defence</small>
          <p class="tw-text-xs c-blue-text">Free limit KSH 10,000</p>
        </div>
      </div>
      <div class="tw-flex tw-items-center tw-mt-3">
        <img src="/images/icons/cross.png" class="tw-w-12 tw-h-12" alt="tow">
        <div class="tw-ml-3">
          <small class="tw-mt-2 c-gray-text">Medical expenses</small>
          <p class="tw-text-xs c-blue-text">Free limit KSH 50,000</p>
        </div>
      </div>
      <div class="tw-flex tw-items-center tw-mt-3">
        <img src="/images/icons/car1.png" class="tw-w-12 tw-h-12" alt="tow">
        <div class="tw-ml-3">
          <small class="tw-mt-2 c-gray-text">Third party person liability</small>
          <p class="tw-text-xs c-blue-text">Any Person KSH 3,000,000/Any One Event KSH 5,000,000</p>
        </div>
      </div>
      <div class="tw-flex tw-items-center tw-mt-3">
        <img src="/images/icons/car3.png" class="tw-w-12 tw-h-12" alt="tow">
        <div class="tw-ml-3">
          <small class="tw-mt-2 c-gray-text">Passengers liability</small>
          <p class="tw-text-xs c-blue-text">Any Person KSH 3,000,000/Any One Event KES 20,000,000</p>
        </div>
      </div>
      <div class="tw-flex tw-items-center tw-mt-3">
        <img src="/images/icons/hit.png" class="tw-w-12 tw-h-12" alt="tow">
        <div class="tw-ml-3">
          <small class="tw-mt-2 c-gray-text">Third party property damage</small>
          <p class="tw-text-xs c-blue-text">Free limit KSH 5,000,000</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Benefits',
};
</script>
